$(document).ready(function () {

    $('.delete').on('click', function () {
        return confirm('Veuillez confirmer la suppresion');
    });

});